import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { UserData } from '../../providers/user-data';
import { ParkbewilligungenData, PbKategorieTyp } from '../../pages/parkbewilligungen/parkbewilligungen-data';

import moment from 'moment';

@Component({
  selector: 'pbkategorielistitem',
  templateUrl: 'pbkategorielistitem.html'
})
export class PbkategorielistitemComponent {
  public PbKategorieTyp = PbKategorieTyp;
  private _pbkatid;
  dauer: string = "";
  @Input('pbkatid') 
  get pbkatid(): number {
    return this._pbkatid;
  }
  set pbkatid(value: number) {
    this._pbkatid = value;    
  }      

  private _pbkat;
  @Input('pbkat') 
  get pbkat(): any {
    return this._pbkat;
  }
  set pbkat(value: any) {
    this._pbkat = value;   
    if(value){
      switch (value.bestelltyp) {
        case PbKategorieTyp.FixeDauer: 
          this.dauer = value.dauer + " Tage";
        break;
        case PbKategorieTyp.FixerZeitraum:
          this.dauer = moment(value.datum_von).format('DD.MM.YYYY') + ' - ' + moment(value.datum_von).add(value.dauer-1, 'd').format('DD.MM.YYYY')
          break;
         
        case PbKategorieTyp.Permanent:
          this.dauer = this.pbData.getBestelltypName(value.bestelltyp);
        break;
        default:
          this.dauer = '';
      }    
  
    }

  }      


  @Output() pbkategorieSelected: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public pbData: ParkbewilligungenData,
    public userData: UserData

    ) {

  }

  select(){
    if(this.pbkategorieSelected){
      this.pbkategorieSelected.emit(this._pbkat);
    }
  }


}



// WEBPACK FOOTER //
// ./src/components/pbkategorielistitem/pbkategorielistitem.ts